import { render } from "./EventRewardSelect.vue?vue&type=template&id=805b6914"
import script from "./EventRewardSelect.vue?vue&type=script&lang=js"
export * from "./EventRewardSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__